<block-ui class="router-outlet-wrapper">
  <router-outlet></router-outlet>
</block-ui>
